import SelectWeekday from "@/views/crud/modules/SelectWeekday.vue";
import ChargingRateDetail from "@/views/custom/ChargingRateDetail.vue";
import SelectCpByChargingRate from "@/views/crud/modules/SelectCpByChargingRate.vue";
import BaseSelect from "@/views/crud/modules/BaseSelect.vue";

export default {
    key: "bay",
    action: ["create","edit","delete"],
    sort_fields:[
        "bayId",
        "inTime",
        "outTime",
        "lupdDttm",
        "cpLocId",
        "mallId",
        "locId",
        "cpId",
        "penaltyMode"
    ],
    filters: {
        id: {},
        bayId: {},
        bayName: {},
        type: {
            type: "select",
            label: "name",
            value: "code",
        },
        cpId: {
            type: "select"
        },
        mallId: {
        },
        locId:{},
        cpLocId:{
            type: "select"
        },
        brand:{},
        licensePlate:{},
        status:{
            type: "select"
        },
        penaltyMode:{
            type:"select"
        }
    },

    fields: [
        {key: "id"},
        {key: "bayId",
            type: "href",
            url: "bay_log/",
            url_key: [
                {
                    search_key: "bayId",
                    row_key: "bayId",
                    str: ""
                }
            ]
        },
        {key :"bayName"},
        {key: "type", field:"type.name", value:"type.code", type:"select"},
        {key: "cpLocId",  component:BaseSelect,
            disabledFun:d=>d.type!='Tesla', multiple:false, filterable:false,  type:"componentColumn",
            optionKey: "cp_locs",
            // options: {
            //     key: "cp_locs",
            //     label: "address",
            //     value: "loc_id"
            // },
            setup:{label:'label',value:'value'},
            // hidden:["list"]
        },
        {key :"mallId"},
        {key :"locId"},
        {key :"cpId",
            options: {
                key: "cps",
                label: "cp_no",
                value: "cp_id"
            },
            type:"select", disabled_by_column:true},
        {key :"connectorId",
            options: {
                key: "connector",
                label: "name",
                value: "connector_id"
            },
            type:"select", hidden:["list"]
        },
        // {key: "cpId", component:SelectWeekday, multiple:false, filterable:true,  type:"componentColumn", optionKey: "cps"},
        {key: "cpConnector", component:BaseSelect, disabledFun:d=>d.type=='Tesla', multiple:false, filterable:true,  type:"componentColumn", optionKey: "vw_cp_connector", setup:{label:'label',value:'value'}
            // , hidden:["list"]
        },
        // {key :"connectorId", type: "sub-select"},
        {key :"brand"},
        {key :"licensePlate"},
        // {key :"lpIn"},
        // {key :"lpOut"},
        {key :"inTime" ,type: "datetime"},
        {key :"outTime",type: "datetime"},
        // {key: "type"},
        {key: "autoDownloadFlag", type:"boolean"},
        {key: "status"},
        {key: "penaltyMode", field:"penaltyMode.name", value:"penaltyMode.code", type:"select"},
        {key: "image", type: "hrefweb"},
        {key: "lupdDttm", type:"datetime"},
        {type: "action-btn", privilege: ["EDIT_BAY"]},
        {key: "urlGetBayInfo", hidden:["list"]},
    ],
    options: {
        type: {
            key: "bay_type",
            label: "name",
            value: "code"
        },
        cpLocId: {
            key: "cp_locs",
            label: "address",
            value: "loc_id"
        },
        cpId: {
            key: "cps",
            label: "cp_no",
            value: "cp_id"
        },
        connectorId: {
            key: "connector",
            label: "name",
            value: "connector_id"
        },
        cpConnector:{
            key: "vw_cp_connector",
            label: "cpConnectorName",
            value: "cpConnectorId"
        },
        cpConnectorNull:{
            key: "vw_cp_connector_null",
            label: "cpConnectorName",
            value: "cpConnectorId"
        },
        status:{
            key: "bay_status",
            label: "name",
            value: "code"
        },
        penaltyMode:{
            key: "penalty_mode",
            label: "name",
            value: "code"
        }
    },
    structure:[
        ["bayId", "type"],
        ["penaltyMode"],
        ["bayName"],
        ["cpConnector"],
        ["cpLocId"],
        ["urlGetBayInfo"],
        ["autoDownloadFlag"]
    ],
    view: [
        // ["bayId", "type.name"],
        // ["cpId","connectorId"]
    ],
    disabled_by_column:{
        edit:[
            {key:"type", val: "Tesla", type:"eq"}
        ]
    },
    extra_components: {
        // view: [
        //     ChargingRateDetail
        // ]
    }
}